const urlScheme = __APP__.replace(/[^a-zA-Z]/g, '') + '.snappit';

const config = {
	getAppVersion: function () {
		return __VERSION__;
	},
	getCommitHash: function () {
		return __COMMIT_HASH__;
	},
	ua: navigator.userAgent.toLowerCase(),
	BaseServerUrl: __BACKEND_URL__, //TODO use Utils.getUrlWithCorrectProtocol
	PusherKey: __PUSHER_KEY__,
	prodMode: __IS_PROD__,
	buildToken: __BUILD_TOKEN__,
	currentAppId: __APP__,
	defaultAppId: __DEFAULT_APP__,
	hasVideo: __APP__ === 'pinkfish' || __APP__ === 'pinkfishasia',
	hasAnimatedImage: __APP__ === 'pontus',
	urlScheme,
	fallbackUrl: urlScheme + '://',
	defaultLanguage: 'en',
	manifestRootUrl: __MANIFEST_URL__,
	operatingStatusUrl: __OPERATING_STATUS_URL__,
	sentryDsn: __SENTRY_DSN__,
	amplitudeApi: __AMPLITUDE_API__,
	adyenEnvironment: __ADYEN_ENVIRONMENT__,
	adyenLocale: __ADYEN_LOCALE__,
	reCaptchaSiteKey: __RECAPTCHA_SITE_KEY__,
	googleMapsApiKey: __GOOGLE_MAPS_API_KEY__
};

export default config;
